import React from "react"
import { Form, message } from "antd"
import InputField from "../Common/InputField"
import { authApi } from "../../Apis/authApis"
import { ProfileUpdate } from "../../Apis/profileupdateApis"
import usePasswordValidation from "../../utils/PasswordCheck"
import { translations } from "../../utils/Translation/staticTranslation"

const ResetPassword = () => {
  const [form] = Form.useForm()
  const lang = localStorage.getItem("language") || "ar"
  const settingPage = translations[lang]?.settingPage
  const common_btn = translations[lang]?.common_btn

  const { passwordChecked, validatePassword } = usePasswordValidation()

  const onFinish = async (values) => {
    if (!passwordChecked.lengthCheck || !passwordChecked.otherChecks) {
      return message.error(settingPage?.passwordMatch)
    }

    const payload = {
      password: values.password,
      confirm_password: values.confirm_password,
    }

    try {
      const response = await ProfileUpdate.updatePassword(payload)

      if (response.status === 200) {
        message.success(
          `${lang === "en" ? response.data.msg : response.data.msgArabic}`
        )
        form.resetFields()
      }
    } catch (error) {
      message.error(
        lang === "en"
          ? error.response.data.detail
          : error.response.data.detailArabic
      )
      console.error("Error:", error)
    }
  }

  return (
    <div className="d-flex flex-column flex-grow-1">
      <p className="text-16 font-600 text-0A083B mb-18">
        {settingPage?.reset_your_password}
      </p>
      <div className="store-resubmission mb-18">
        <div className="d-flex">
          <div className={`${lang === "ar" ? "ml-10" : "mr-10"}`}>
            <img src="/icons/infoyellow.svg" alt="" />
          </div>
          <p style={{ maxWidth: "800px" }}>
            {settingPage?.password_requiremnts}
          </p>
        </div>
      </div>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <InputField
          formclass="w-100"
          label={settingPage?.current_password}
          name="current_password"
          placeholder={settingPage?.current_password_placeholder}
          type="password"
          className="setting-input-field"
          rules={[
            { required: true, message: settingPage?.current_password_error },
          ]}
        />
        <InputField
          onChange={(e) => validatePassword(e.target.value)}
          formclass="w-100"
          label={settingPage?.new_password}
          name="password"
          placeholder={settingPage?.new_password_placeholder}
          type="password"
          className="setting-input-field"
          rules={[{ required: true, message: settingPage?.new_password_error }]}
        />
        <InputField
          formclass="w-100"
          label={settingPage?.confirm_password}
          name="confirm_password"
          placeholder={settingPage?.confirm_password_placeholder}
          type="password"
          className="setting-input-field"
          rules={[
            {
              required: true,
              message: settingPage?.confirm_password_error,
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve()
                }
                // message.error("Passwords do not match!");
                return Promise.reject(new Error(settingPage?.passwordMatch))
              },
            }),
          ]}
        />
        <div className="d-flex justify-content-end">
          <button
            className={`cancel-btn ${lang === "ar" ? "ml-10" : "mr-10"}`}
            // onClick={() => setEditDetails(!editDetails)}
          >
            {settingPage?.discard_btn}
          </button>
          <button
            type="submit"
            className="pxy-13-26 border-none bg-504943 border-radius-59 text-FFFFFF"
          >
            {settingPage?.change_password_btn}
          </button>
        </div>
      </Form>
    </div>
  )
}

export default ResetPassword
